module.exports = __webpack_public_path__ + "static/media/CLC_cover_08.87628c2d.jpg";